import React, { useState } from "react";
import { Drawer, Avatar, Upload } from "antd";
import { CloseOutlined, RightOutlined, UserOutlined } from "@ant-design/icons";
import { CameraIcon, VerifyIcon } from "../Icons/Icons";
import { sidebarConfig } from "../sidebarConfig";
import { useLayout } from "../Context/LayoutContext";

const MobileProfileDrawer = ({
  open,
  onClose,
  profile,
  uploadProps,
  commonProps,
}) => {
  const { chat, setChat } = useLayout();
  const [support,setSupport]=useState(false)

  const [activeComponent, setActiveComponent] = useState(null);
  const [dyncTitle, setDyncTitle] = useState()

const handleMobileMenuClick = (item) => {
  setActiveComponent(item.component || null);
  setDyncTitle(item.label);

  const supportKeysForChat = ["promo", "webinar", "guide", "more", "market"];

  if (supportKeysForChat.includes(item.key)) {
    // Support section WITH chat
    setChat(true);
    setSupport(true);
  } 
  else if (item.key === "support") {
    // Support section WITHOUT chat
    setSupport(true);
    setChat(false);
  } 
  else {
    // Normal sections
    setChat(false);
    setSupport(false);
  }
};


  console.log(chat, 'chat');


  return (
    <Drawer
      title={`${!activeComponent ? "Profile" : ""}`}
      placement="right"
      onClose={() => {
        setActiveComponent(null);
        onClose();
      }}
      open={open}
      closable={!activeComponent}
      getContainer={false}
      closeIcon={<CloseOutlined style={{ color: "#888" }} />}
      className="profile-drawer"
      style={{ backgroundColor: "var(--bg-mn)" }}
    >
      <div style={{ height: "100%" }}>
        {!activeComponent && (
          <div
            style={{
              margin: "0 auto",
              padding: 16,
              // backgroundColor: "var(--bg-mn4)",
              color: "#fff",
              height: "calc(100vh - 57px)",
            }}
          >
            {/* HEADER - Avatar + Name */}
            <div style={{ textAlign: "center" }} className="card-profile">
              <Avatar
                size={50}
                icon={
                  <UserOutlined
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "#636262",
                    }}
                    className="display-3"
                  />
                }
                src={profile?.profile_image || profile?.name}
                style={{ backgroundColor: "transparent" }}
              />

              <div className="test display-3 gap-5 align-baseline">
                <div style={{ marginTop: 16, color: "#fff" }}>
                  {profile?.name || "User"}
                </div>
                <VerifyIcon />
              </div>

              <div style={{ width: "max-content", margin: "auto" }}>
                <Upload {...uploadProps}>
                  <p className="display-1 p-profile">
                    <CameraIcon /> Upload a Photo
                  </p>
                </Upload>
              </div>
            </div>

            {/* MENU LIST */}
            <div style={{ marginTop: 16 }}>
              {sidebarConfig(commonProps)
                .filter((item) => !item.logout && !item.hide)
                .map((item) => (
                  <div
                    key={item.key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    onClick={() => handleMobileMenuClick(item)}
                  >
                    <div className="display-2 gap-10">
                      {item.icon}
                      <span style={{ color: "#fff" }}>{item.label}</span>
                    </div>
                    <RightOutlined style={{ color: "#888" }} />
                  </div>
                ))}

              {/* LOGOUT */}
              {sidebarConfig(commonProps)
                .filter((item, i) => item.logout)
                .map((item, i) => (
                  <div
                    key="logout"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: 16,
                    }}
                  >
                    <div className="display-2 gap-5">
                      {item.icon}
                      <span style={{ color: "#f80303" }}>{item.label}</span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* Active Component Screen */}
        {activeComponent && (
          <div style={{ padding: 0, 
          // minHeight: "100vh",
           position: "relative", display: "flex", flexDirection: "column", height: support ? "100%" :"auto" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                // marginBottom: 16,
                padding: "15px",
                position: "sticky",
                background: "var(--bg-mn)",
                top: 0,
                zIndex: "9999"
              }}
              onClick={() => {
                setActiveComponent(null);
       setChat(false);
  setSupport(false);     // ← FIX

              }}
            >
              <RightOutlined
                style={{
                  transform: "rotate(180deg)",
                  marginRight: 8,
                  color: "var(--fnt)",
                }}
              />
              <div className="side-title display-1">
                {dyncTitle}</div>
            </div>

            <div className="mob-active-component"
              style={{ display: "flex", flex: "1", flexDirection: chat && "column" }}
            >
              {activeComponent}
            </div>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default MobileProfileDrawer;
